import range from 'lodash/range';
import { VisuallyHidden } from '@radix-ui/react-visually-hidden';
import { keyframes, styled } from 'theme';
import { fadeIn } from 'theme/animations';
import Card from 'components/V1/Card/Card';

const pulse = keyframes({
  '0%': { backgroundPosition: '0% 0%' },
  '100%': { backgroundPosition: '-135% 0%' },
});

/*
 * Elements for building skeleton loading states
 */
export const Skeleton = styled('div', {
  // Reset
  boxSizing: 'border-box',

  display: 'inline-block',
  height: '100%',
  width: '100%',
  maxWidth: '100%',
  background: 'linear-gradient(-90deg, #f0f0f0 0%, #f8f8f8 50%, #f0f0f0 100%)',
  backgroundSize: '400% 400%',
  animation: `${pulse} 1.2s ease-in-out infinite`,

  '&::before': {
    content: '"loading..."',
    visibility: 'hidden',
  },
});

export const SkeletonLine = styled(Skeleton, {
  borderRadius: '$sm',
});

interface SkeletonCardProps {
  lines?: number;
}

export function SkeletonCard({ lines = 10 }: SkeletonCardProps) {
  return (
    <Card
      css={{
        p: '$6',
        opacity: 0,
        animation: `${fadeIn} 600ms ease 250ms`,
        animationFillMode: 'forwards',
      }}
    >
      <VisuallyHidden>Loading...</VisuallyHidden>
      {range(lines).map((i) => (
        <SkeletonLine key={i} css={{ my: '$3' }} />
      ))}
    </Card>
  );
}
